module.exports = __webpack_public_path__ + "img/img.197b9b3a.png";